module.exports = __webpack_public_path__ + "img/banner-lotto.13e0160e.jpg";